import { AuthConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root";
import { useTranslation } from "react-i18next";

export const useAuthConfig = () => {
  const { config } = useRootLoaderData();
  const authConfig = config.Auth as AuthConfigSection;
  const { t } = useTranslation();

  const validatePassword = (password: string) => {
    const errors: string[] = [];
    if (password.length < authConfig.PasswordRequiredLength) {
      errors.push(t("ui.PasswordTooShort", { defaultValue: "Too Short", replace: { len: authConfig.PasswordRequiredLength } }));
    }
    if (authConfig.PasswordRequiresLowercase && !/[a-z]+/gu.test(password)) {
      errors.push(t("ui.PasswordRequiresLowercase", "Requires Lowercase"));
    }
    if (authConfig.PasswordRequiresUppercase && !/[A-Z]+/gu.test(password)) {
      errors.push(t("ui.PasswordRequiresUppercase", "Requires Uppercase"));
    }
    if (authConfig.PasswordRequiresDigit && !/[0-9]+/gu.test(password)) {
      errors.push(t("ui.PasswordRequiresDigit", "Requires Number"));
    }
    if (authConfig.PasswordRequiresNonAlphanumeric && !/[^a-zA-Z\d]+/gu.test(password)) {
      errors.push(t("ui.PasswordRequiresNonAlphanumeric", "Requires Symbol"));
    }
    return errors.length > 0 ? errors.join(", ") : true;
  };

  return { config: authConfig, validatePassword };
};
